import { useLocalizationContext } from "localization/LocalizationProvider";
import { Locales } from "localization/types";
import * as React from "react";
import { RoomStatus } from "types";
import { useGameContext } from "../context/GameContext";
import LobbyScreen from "../lobby/components/LobbyScreen";
import GameScreen from "./GameScreen";
import GameFailed from "./game-failed";
import GameOver from "./game-over";

const RoomStatusRendering: React.FC = () => {
	const { room } = useGameContext();
	const { updateTranslations } = useLocalizationContext();

	React.useEffect(() => {
		if (room?.language && room?.roomTemplateId) {
			updateTranslations({
				locale: room.language as Locales,
				organizationId: room.organization.id,
				roomTemplateId: room.roomTemplateId,
			});
		}
	}, [room?.language, room?.organization.id, room?.roomTemplateId, updateTranslations]);

	return (
		<>
			{room?.status === RoomStatus.READY && <>{room.users.length > 1 ? <LobbyScreen /> : <GameScreen />}</>}
			{room?.status &&
				[RoomStatus.IN_GAME, RoomStatus.AWAITING, RoomStatus.ISSUE].includes(room?.status as RoomStatus) && (
					<GameScreen />
				)}
			{room?.status === RoomStatus.DONE && <GameOver />}
			{room?.status === RoomStatus.FAILED && <GameFailed />}
		</>
	);
};

export default RoomStatusRendering;
